module.exports = __webpack_public_path__ + "static/media/discover-screenshot-beyonce.bd1aa22c.png";